import { BasicResponsiveImage, Box, Callout } from '@vp/swan';
import { useStyles } from '@vp/ubik-context';
import styles, { stylesheet } from './ImageTile.module.scss';

interface Image {
    src: string;
    altText: string;
    industry: string;
}

interface ImageTileProps {
    image: Image;
    position?: 'center' | 'left' | 'right' | 'hidden';
    isTabbable?: boolean;
}

const ImageTile = ({ image, position, isTabbable = true }: ImageTileProps) => {
    useStyles(stylesheet);

    return (
        <Box className={styles.imageTile} tabIndex={isTabbable ? 0 : -1}>
            <BasicResponsiveImage
                src={image.src}
                alt={image.altText}
                aspectRatio={1}
                style={{
                    width: '100%',
                    height: '100%',
                }}
            />
            <Box
                className={`${styles.calloutWrapper} ${position === 'center' ? styles.centerTile : ''}`}
            >
                <Callout>{image.industry}</Callout>
            </Box>
        </Box>
    );
};

export default ImageTile;
